import type { CSSProperties } from "react";
import type { Theme } from "../theme/pixel";
import type { Faction } from "../theme/factions";

interface Props {
  filled: boolean;
  exists: boolean;
  theme: Theme;
  faction: Faction;
}

export function ManaIcon({ filled, exists, theme, faction }: Props) {
  const size = 20;
  const style: CSSProperties = {
    width: size,
    height: size,
    background: filled ? faction.color : exists ? theme.panelSolid : "transparent",
    border: `2px solid ${
      exists ? (filled ? theme.panelEdgeStrong : theme.panelEdge) : theme.inkFaint
    }`,
    opacity: !exists ? 0.35 : 1,
    boxShadow: filled
      ? "inset 2px 2px 0 rgba(255,255,255,0.4), inset -2px -2px 0 rgba(0,0,0,0.35)"
      : "none",
    imageRendering: "pixelated",
    flexShrink: 0,
  };
  return <div style={style} />;
}
